import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Homepage from './components/Homepage';
import Quiz from './components/Quiz';
import OurStory from './components/OurStory';
import LandingPage from './components/LandingPage';
import Contact from './components/Contact';
import ShopCollections from './components/ShopCollections';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          {/* <Route path="/" element={<Homepage />} /> */}
          <Route path="/" element={<Navigate to="/quiz/1" replace />} />
          <Route path="/page" element={<LandingPage />} />
          <Route path="/quiz" element={<Navigate to="/quiz/1" replace />} />
          <Route path="/quiz/:step" element={<Quiz />} />
          <Route path="/our-story" element={<OurStory />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/collections" element={<ShopCollections />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
